const helperKeys = [
  'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
  'ArrowLeft', 'ArrowRight', 'Home', 'End'
]

function keydownHandler(e) {
  if (helperKeys.includes(e.key) || (e.ctrlKey || e.metaKey)) return

  if (!/^[0-9]$/.test(e.key)) {
    e.preventDefault()
  }
}

function pasteHandler(e) {
  const text = e.clipboardData.getData('text')

  if (!/^\d+$/.test(text)) {
    e.preventDefault()
  }
}

export default {
  mounted(el) {
    el.addEventListener('keydown', keydownHandler)
    el.addEventListener('paste', pasteHandler)
  },

  unmounted(el) {
    el.removeEventListener('keydown', keydownHandler)
    el.removeEventListener('paste', pasteHandler)
  }
}